import styles from "./styles.module.scss";
import Section from "../../components/Section";
import figma_icon from "../../graphics/figma_icon.svg";
import img5 from "../../images/5.png";

import animation from "../../videos/animation.mp4";

const Animation = () => {
  return (
    <Section color="#1D1D1D">
      <div className={styles.container}>
        <div className={styles.title}>
          <div>
            <img src={img5} alt="1" />
          </div>
          <h1>АНИМАЦИЯ</h1>
        </div>
        <div className={styles.content}>
          <div className={styles.col}>
            <div>
              <h4 className={styles.sub_title}>Задача</h4>
              <p className={styles.text}>
                Разработка анимации для туристической компании, которая
                занимается организацией недельных туров в горы.Была поставлена
                задача реализовать идею заказчика в оригинальном и реалистичном
                стиле, используя фотокарточки их клиентов.
              </p>
            </div>
            <div>
              <h4 className={styles.sub_title}>Реализация</h4>
              <div className={styles.logo_text}>
                <div>
                  <img src={figma_icon} alt="Figma" />
                </div>
                <p>Figma</p>
              </div>
            </div>
          </div>
          <div className={styles.video}>
            <video muted loop autoPlay>
              <source type="video/mp4" src={animation}></source>
            </video>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Animation;
